import { PERMISSIONS } from '@helios/authz';
import { useScopedOperationalMutation, useScopedOperationalQuery } from '@/hooks/useScopedOperationalQuery';
import { testingApi } from './testing.api';

export function useTestingCommandCenter() {
  return useScopedOperationalQuery('testing', PERMISSIONS.PLATFORM_ADMIN, testingApi.getDashboard, 60_000);
}
export function useRunCriticalPlan() {
  return useScopedOperationalMutation('testing', PERMISSIONS.PLATFORM_ADMIN, (_input: void, options) => testingApi.runCriticalPlan(undefined, options));
}
